/**
 * Pure helpers for the pipeline graph run-status overlay.
 */

/**
 * Format a step duration for the node chrome.
 * Examples: `4.1s`, `320ms`, `—` when unknown.
 */
export function formatStepDuration(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms)) return "—"
  if (ms < 1000) return `${Math.round(ms)}ms`
  return `${(ms / 1000).toFixed(1)}s`
}
